import React from 'react';

export const ThemeContext = React.createContext('');

export enum APP_THEMES {
	GSK = 'gsk',
}
